// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1A8Ls","buttons":"PendingPaymentAlert_buttons__24xdz"};